import { CategoryType } from "../exercises.types";
import { ThemeModule } from "./theme.types";
import { VoirNestPasToujoursCroire } from "../explorer/Illusions/VoirNestPasToujoursCroire";

export const voirNestPasToujoursCroireTheme: ThemeModule = {
  id: "voir-nest-pas-toujours-croire",
  title: "Voir n’est pas toujours croire",
  description:
    "Un thème pour découvrir comment notre perception peut nous tromper, et pourquoi notre cerveau interprète parfois la réalité de travers.",
  category: CategoryType.EXPLORER,
  keywords: ["perception", "illusion", "cerveau", "vision"],
  explorerExperiences: [VoirNestPasToujoursCroire],
  estimatedDuration: 5,
  level: "debutant",
  minAgeBand: "6-8",
  allowedRoles: ["enfant", "eleve", "parent", "enseignant"],
};
